import styled from 'styled-components';
import backNoteImg from '../../../../static/images/equipment/note.png';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Label from '@ertelecom/ui-react/components/label';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';

export const SmartWrapper = styled.div`
    width: 100%;
    padding: 20px 0 70px;
`;
export const SmartHeader = styled.div`
    display: flex;
    margin-bottom: 50px;
    box-sizing: border-box;
    height: 370px;
    padding-left: 5%;
    width: 90%;
    @media (max-width: 600px) {
        width: 100%;
        padding: 0;
        height: 420px;
        flex-direction: column-reverse;
        justify-content: space-between;        
    }
`;
export const SmartHeaderInfo = styled.div`
    display: flex;
    width: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    
    @media (max-width: 600px) {
        padding: 0;
        width: 100%;
    }
`;

export const SmartNoteImg = styled.div`
    width: 50%;
    background: url(${backNoteImg}) no-repeat right center;
    background-size: contain;
    @media (max-width: 600px) {
        background-position: center center;
        width: 100%;
        height: 220px;
    }
`;

export const SmartHeaderTitle = styled.div`
    width: 100%;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 30px;
    padding-right: 15%;
    @media (max-width: 1500px) {
        font-size: 20px;
        line-height: 28px;
    }
    @media (max-width: 1100px) {
        font-size: 16px;
        line-height: 20px;
    }
    @media (max-width: 600px) {
        padding: 0;
    }
`;
export const SmartHeaderAction = styled(StyledButton)`
    max-width: 350px;
    @media (max-width: 600px) {
        max-width: 100%;
        width: 100%;
    }
`;
export const SmartHeaderLabel = styled(Label)`
    margin-bottom: 20px;
    width: auto;
`;
export const TvTable = styled.div`
    background: ${COLORS.white};
    border: 1px solid ${COLORS.outlineGrey};
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px 50px;
`;
export const TvTableRow = styled.div`
    border-bottom: 1px solid ${COLORS.grey};
    width: 100%;
    display: flex;
    padding: 30px 0;
    :last-child {
        border-bottom: 0; 
    }
    @media (max-width: 600px) {
        flex-direction: column;
    }
`;
export const TvTableRowTitle = styled.div`
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    font-size: 16px;
    line-height: 20px;
    border-right: 1px solid ${COLORS.grey};
    width: 35%;    
    padding-right: 5%;
    @media (max-width: 600px) {
        border-right: 0;
        padding-right: 0;
        width: 100%;
        margin-bottom: 10px;
    }
`;
export const TvTableRowDesc = styled.div`
    font-size: 16px;
    line-height: 20px;
    width: 65%;
    padding-left: 5%;
    @media (max-width: 600px) {
        padding-left: 0;
        width: 100%;
    }
`;

export const LinksContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: left;
`;

export const EquipLink = styled.a`
    text-decoration: underline;
`;

export const NoteLink = styled(EquipLink)`
    margin-right: 20px;
`;
